export default __webpack_public_path__ + "static/media/createPro.72f773c3.png";